import AccessControl from '@modules/auth/AccessControl'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectSpecialityField from '@modules/formFields/SelectSpecialityField'
import { TextAreaField } from '@modules/formFields/TextAreaField'
import React, { Component } from 'react'
import { withTranslation, Trans } from 'react-i18next'
import { Field, Form, reduxForm, SubmissionError } from 'redux-form/dist/redux-form'
import { compose } from 'redux'
import Consultations from '@services/Consultations'
import { history } from '@services/History'

class SentenceForm extends Component {
  static defaultProps = {
    initialValues: {},
  }

  submit = (values) => {
    const requestBody = {
      id: values.id,
      string: values.string,
      speciality_ids: values.specialities && values.specialities.map((speciality) => speciality.id),
      company_api_keys: values.companies && values.companies.map((company) => company.api_key),
    }

    if (this.props.initialValues.id) {
      return Consultations.sentence
        .update(this.props.initialValues.id, requestBody)
        .then(() => history.push(`/sentence/${this.props.initialValues.id}`))
        .catch((err) => {
          throw new SubmissionError({ ...err.response.data.errors, _error: err.message })
        })
    }

    return Consultations.sentence
      .store(requestBody)
      .then(() => history.push('/sentence'))
      .catch((err) => {
        throw new SubmissionError({ ...err.response.data.errors, _error: err.message })
      })
  }

  render() {
    const { handleSubmit, submitting } = this.props
    const { t } = this.props
    return (
      <Form className="md-form" onSubmit={handleSubmit(this.submit)}>
        <Field name="string" component={TextAreaField} label={<Trans>Frase</Trans>} placeholder={t('Frase')} />
        <AccessControl role="superAdmin">
          <Field
            multi
            name="companies"
            component={SelectCompanyField}
            label={<Trans>Compañías</Trans>}
            placeholder={t('Compañías')}
          />
        </AccessControl>
        <Field
          multi
          name="specialities"
          component={SelectSpecialityField}
          label={<Trans>Especialidades</Trans>}
          placeholder={t('Especialidades')}
        />
        {this.props.error && this.props.submitFailed && (
          <div className="error">
            <div>{this.props.error}</div>
          </div>
        )}
        <button type="submit" className="btn btn-primary" disabled={submitting}>
          <Trans>Guardar</Trans>
        </button>
      </Form>
    )
  }
}

const validate = (values, props) => {
  const { t } = props
  const errors = {}
  if (!values.string) {
    errors.string = t('Campo requerido')
  }
  if (!values.companies || values.companies.length === 0) {
    errors.companies = t('Campo requerido')
  }
  if (!values.specialities || values.specialities.length === 0) {
    errors.specialities = t('Campo requerido')
  }
  return errors
}

export default compose(withTranslation(), reduxForm({ form: 'sentence', validate }))(SentenceForm)
